import React from 'react';
import Button from '../ui/Button';

function formatPercent(value) {
  return `${Number(value || 0).toFixed(1)}%`;
}

function AttendanceRiskDetailDrawer({ row, groupBy = 'none', onViewPeople = null }) {
  if (!row) {
    return (
      <div className="director-card">
        <div className="role-section-header">
          <h2>Attendance Detail</h2>
          <span>Select a row</span>
        </div>
        <p className="role-section-copy">
          Select a person or grouping row to review its current attendance risk summary.
        </p>
      </div>
    );
  }

  if (groupBy !== 'none') {
    return (
      <div className="director-card director-attendance-drawer">
        <div className="role-section-header">
          <h2>{row.displayLabel}</h2>
          <span>{groupBy === 'supervisor' ? 'Supervisor Group' : 'Location Group'}</span>
        </div>
        <p className="role-section-copy">
          {row.employeeCount} people in this group, with {row.criticalCount} critical, {row.concernCount} concern, and {row.watchCount} watch risks.
        </p>

        <div className="director-split-grid">
          <section className="director-card">
            <div className="role-section-header">
              <h2>Group Summary</h2>
              <span>Employee Mix</span>
            </div>
            <div className="table-card">
              <table className="role-table">
                <tbody>
                  <tr>
                    <th>Total People</th>
                    <td>{row.employeeCount}</td>
                  </tr>
                  <tr>
                    <th>Roster-Linked</th>
                    <td>{row.managerBackedEmployeeCount}</td>
                  </tr>
                  <tr>
                    <th>Standalone</th>
                    <td>{row.standaloneEmployeeCount}</td>
                  </tr>
                  <tr>
                    <th>Discipline Review</th>
                    <td>{row.disciplineReviewCount}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section className="director-card">
            <div className="role-section-header">
              <h2>Risk Metrics</h2>
              <span>Current Aggregate</span>
            </div>
            <div className="table-card">
              <table className="role-table">
                <tbody>
                  <tr>
                    <th>Average At Work %</th>
                    <td>{formatPercent(row.averageAtWorkRate)}</td>
                  </tr>
                  <tr>
                    <th>Lowest At Work %</th>
                    <td>{formatPercent(row.lowestAtWorkRate)}</td>
                  </tr>
                  <tr>
                    <th>Incidents (30d)</th>
                    <td>{row.totalIncidents30 || 0}</td>
                  </tr>
                  <tr>
                    <th>Incidents (60d)</th>
                    <td>{row.totalIncidents60 || 0}</td>
                  </tr>
                  <tr>
                    <th>Incidents (90d)</th>
                    <td>{row.totalIncidents90 || 0}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
        </div>

        {onViewPeople ? (
          <div className="director-form-actions">
            <Button variant="secondary" onClick={onViewPeople}>View People</Button>
          </div>
        ) : null}
      </div>
    );
  }

  return (
    <div className="director-card director-attendance-drawer">
      <div className="role-section-header">
        <h2>{row.displayLabel}</h2>
        <span>{row.locationCode}</span>
      </div>
      <p className="role-section-copy">
        At Work {formatPercent(row.atWorkRate)} with alert level <strong>{row.alertLevel}</strong> and trend <strong>{row.trend}</strong>.
      </p>

      <div className="director-split-grid">
        <section className="director-card">
          <div className="role-section-header">
            <h2>30 / 60 / 90 Breakdown</h2>
            <span>Rolling Incident Counts</span>
          </div>
          <div className="table-card">
            <table className="role-table">
              <thead>
                <tr>
                  <th>Window</th>
                  <th>At Work %</th>
                  <th>Sick</th>
                  <th>Absence</th>
                  <th>Late</th>
                  <th>Eligible</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>30 Days</td>
                  <td>{formatPercent(row.atWorkRate)}</td>
                  <td>{row.sick30 || 0}</td>
                  <td>{row.absence30 || 0}</td>
                  <td>{row.late30 || 0}</td>
                  <td>{row.eligibleWorkdays || 0}</td>
                </tr>
                <tr>
                  <td>60 Days</td>
                  <td>{formatPercent(row.atWorkRate)}</td>
                  <td>{row.sick60 || 0}</td>
                  <td>{row.absence60 || 0}</td>
                  <td>{row.late60 || 0}</td>
                  <td>{row.eligibleWorkdays || 0}</td>
                </tr>
                <tr>
                  <td>90 Days</td>
                  <td>{formatPercent(row.atWorkRate)}</td>
                  <td>{row.sick90 || 0}</td>
                  <td>{row.absence90 || 0}</td>
                  <td>{row.late90 || 0}</td>
                  <td>{row.eligibleWorkdays || 0}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        <section className="director-card">
          <div className="role-section-header">
              <h2>Person Context</h2>
              <span>Current Person</span>
          </div>
          <div className="table-card">
            <table className="role-table">
              <tbody>
                <tr>
                  <th>Employee Profile ID</th>
                  <td>{row.employeeProfileId || '-'}</td>
                </tr>
                <tr>
                  <th>Roster Record ID</th>
                  <td>{row.managerId || '-'}</td>
                </tr>
                <tr>
                  <th>Supervisor Employee ID</th>
                  <td>{row.supervisorEmployeeId || '-'}</td>
                </tr>
                <tr>
                  <th>Roster-Linked</th>
                  <td>{row.isManagerBacked ? 'Yes' : 'No'}</td>
                </tr>
                <tr>
                  <th>Discipline Flag</th>
                  <td>{row.disciplineReviewFlag || '-'}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>
      </div>
    </div>
  );
}

export default AttendanceRiskDetailDrawer;
